<div fxLayout="column" fxLayoutGap="1rem">

    <div>
        <h2 fxLayoutAlign="space-between" style="margin:0">
            <span>{{title}}</span>
            <div fxLayout="row" fxLayoutGap="1rem">
                <button mat-button color="primary" [matMenuTriggerFor]="addContentsMenu">
                    <mat-icon>add</mat-icon> Add Media <mat-icon>expand_more</mat-icon>
                </button>
            </div>
        </h2>
    </div>

    <!-- 
    <div fxLayout="row" fxLayoutGap="1rem">
        <button mat-button (click)="openFilterDialog()">
            <mat-icon>filter_alt</mat-icon> Filter
        </button>
        <button mat-button (click)="toggleSortDirection()">
            <mat-icon>sort</mat-icon> Sort
        </button>
    </div> -->

    <div [ngClass]="{'inset': inset}">

        <div *ngIf="elements.size == 0 && !loadingElements">
            <h3 style="margin:0">
                No Media
            </h3>
        </div>

        <div *ngIf="loadingElements">
            <mat-spinner style="margin:0 auto;"></mat-spinner>
        </div>

        <div gdColumns="repeat(4, minmax(auto, 1fr))" gdGap="1rem" style="padding: 3px 0" *ngIf="!loadingElements">
            <mat-card *ngFor="let element of sortedElements; let index = index;" (click)="toggleElementSelect(element)" [ngStyle]="{'cursor':selectMode != ContentGridSelectMode.OFF ? 'pointer': null}">
                <mat-card-content style="height:100%">
                    <div fxLayout="column" style="height:100%">
                        <div style="flex: 1 0 auto;" fxLayoutAlign="center center">
                            <app-content-grid-element-display [element]="element"></app-content-grid-element-display>
                        </div>
                        <div style="text-align: center; flex: 0 0 auto;">
                            <button mat-button mat-icon-button (click)="deleteElement(element)" matTooltip="Delete" color="warn" *ngIf="allowDelete && !(element.deleting || element.uploading || element.reading)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <ng-container *ngIf="selectMode != ContentGridSelectMode.OFF">
                                <button mat-icon-button [color]="element.selected ? 'accent' : 'primary'">
                                    <mat-icon *ngIf="!element.selected && selectMode == ContentGridSelectMode.MULTIPLE">check_box_outline_blank</mat-icon>
                                    <mat-icon *ngIf="element.selected && selectMode == ContentGridSelectMode.MULTIPLE">check_box</mat-icon>
                                    <mat-icon *ngIf="!element.selected && selectMode == ContentGridSelectMode.SINGLE">radio_button_unchecked</mat-icon>
                                    <mat-icon *ngIf="element.selected && selectMode == ContentGridSelectMode.SINGLE">radio_button_checked</mat-icon>
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <div fxFlexFill *ngIf="elements.keys.length != 0 && !loadingElements">
                <div fxLayoutAlign="center center" style="min-height: 200px;">
                    <button mat-fab color="primary" [matMenuTriggerFor]="addContentsMenu" matTooltip="Add Media to Library"><mat-icon>add</mat-icon></button>
                </div>
            </div>
        </div>
    </div>
</div>

<input (change)="onFilesChange($event)" #filesInput type="file" accept="image/png, video/mp4, .gltf, .zip" [multiple]="selectMode == ContentGridSelectMode.MULTIPLE" hidden/>

<mat-menu #addContentsMenu="matMenu">
    <button mat-menu-item (click)="filesInput.click();">From My Computer</button>
    <button mat-menu-item (click)="openAddLinkDialog()">From Youtube/Vimeo</button>
</mat-menu>

<ng-template #addLinkDialog>
    <div fxLayout="column">
        <div>
            <h3 style="margin: 0; text-align: center;">Add from Youtube/Vimeo</h3>
        </div>
        <mat-form-field>
            <mat-label>Link</mat-label>
            <input name="link" matInput required placeholder="Link" [(ngModel)]="link">
        </mat-form-field>
        <div fxLayout="row" fxLayoutGap="1rem">
            <button mat-stroked-button color="warn" type="button" (click)="cancelAddLink()">Cancel</button>
            <button mat-flat-button color="primary" type="button" (click)="addLink()">Add</button>
        </div>
    </div>
</ng-template>

<ng-template #filterDialog>
    <div fxLayout="column">
        <mat-form-field>
            <mat-label>Content Type</mat-label>
            <mat-select multiple #contentType>
                <mat-option [value]="ContentType.IMAGE">Image</mat-option>
                <mat-option [value]="ContentType.VIDEO">Video</mat-option>
                <mat-option [value]="ContentType.STREAM_VIMEO">Vimeo</mat-option>
                <mat-option [value]="ContentType.STREAM_YOUTUBE">Youtube</mat-option>
                <mat-option [value]="ContentType.MODEL">3D Model</mat-option>
            </mat-select>
        </mat-form-field>
        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="end">
            <button mat-stroked-button color="warn">
                Cancel
            </button>
            <button mat-flat-button color="primary" (click)="applyFilter(contentType.value)">
                Apply
            </button>
        </div>
    </div>
</ng-template>